import { ComponentType, ErrorInfo, PureComponent, ReactNode } from 'react';

import { logFundsAccessError } from ':fat/analytics/logMetrics';
import { reportError } from ':fat/init/bugsnag';

export type ErrorFallbackProps = {
  error?: Error;
};

type ErrorBoundaryProps = {
  fallback?: ComponentType<ErrorFallbackProps>;
  children?: ReactNode;
};

type ErrorBoundaryState = {
  error?: Error;
};

export class AppErrorBoundary extends PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    error: undefined,
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logFundsAccessError('error_boundary');
    try {
      reportError(error.message, {
        severity: 'error',
        context: 'app_error_boundary',
        metadata: [
          {
            name: 'didCatch handler',
            data: {
              error,
              errorInfo,
            },
          },
        ],
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Could not report error', err);
    }
  }

  render() {
    const { error } = this.state;
    const { fallback: Fallback, children } = this.props;

    if (error) {
      return Fallback ? <Fallback error={error} /> : null;
    }

    return children;
  }
}
